import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function Orders({ dataa }) {
  const remainingPercentage = 100 - (dataa?.hiringPercentage || 0);

  const data = {
    labels: ["Completed Hiring", "Pending Hiring"],
    datasets: [
      {
        label:[""],
        data: [dataa?.hiringPercentage || 0, remainingPercentage],
        backgroundColor: ["#2C5F2D", "#E5E5E5"],
        borderWidth: 1,
      },
    ],
  };

  return (
    <Doughnut data={data} className="gender-chart" />

  );
}